import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';

@Component({
    selector: 'app-search-text',
    templateUrl: './search-text.component.html',
    styleUrls: []
})
export class SearchTextComponent {
    @Input() label!: string;
    @Input() formElementId!: string;
    @Input() placeholder!: string;
    @Input() parentFormGroup!: UntypedFormGroup;

    get validationErrorLabel() {
        return this.placeholder ? this.placeholder : this.label;
    }

    get control() {
        if (!this.formElementId) {
            throw new Error(`formElementId not set for '${this.label}'.`);
        }

        return this.parentFormGroup.get(this.formElementId) as AbstractControl;
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }
}
